<app-header></app-header>

<section class="not-found">
  <h1>404</h1>

  <p class="description" i18n="Text for the not found page@@NOT_FOUND">We couldn't find what you were looking for.</p>

  <button type="button" class="text-link" [routerLink]="['/home']" i18n="Text for the link to go back to the home page in the not found page@@GO_HOME">Go back to the Home</button>
</section>
